import { FontWeight } from '../ContentText/types.js';

var errorMessageThemeWeb = {
  color: 'alert',
  icon: {
    /**
     * Hide/show the error icon on the left
     */
    visible: true
  }
};
var errorMessageThemeNative = {
  color: 'alert',
  fontSize: 'm',
  fontWeight: FontWeight.regular,
  height: 40,
  icon: {
    marginRight: 8,

    /**
     * Hide/show the error icon on the left
     */
    visible: true
  }
};

export { errorMessageThemeNative, errorMessageThemeWeb };
